export const stateName = 'systemConfiguration';